export const convertToLng = (value: number) => {
  if (value > 180) return value - 360
  if (value < -180) return value + 360
  return value
}
